import { createSpeakingTaskType } from '../../createTaskType';
import SpeakingGenericEditor from '../../sharedLogic/SpeakingGenericEditor';
import {
    createSpeakingHighlightItem as highlightItem,
    createSpeakingPlacementItem as placementItem,
    createSpeakingSimpleItem as simpleItem
} from '../../sharedLogic/speakingItemCreators';
import withProps from "@dyl/utils/withProps";
import speakingConvertToUploadFormat from "@dyl/task-types/sharedLogic/speakingConvertToUploadFormat";

export default createSpeakingTaskType({
    id: 'scene_builder',
    label: 'Scene Builder',
    skill: 'speaking',
    v2: true,

    createItemsTemplate: () => [
        placementItem(),
        highlightItem(),
        highlightItem(),
        simpleItem(),
        placementItem(),
        highlightItem(),
        highlightItem(),
        simpleItem(),
    ],
    editor: withProps(SpeakingGenericEditor, { includeContextAudioField: true }),

    hasEndAudio: true,
    backgroundImages: { count: 1 },

    convertToUploadFormat: speakingConvertToUploadFormat,
});